import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async sendToConcierge(body: ApiSchemas['SendToConciergeDto']) {
    return wrapEndpoint(() =>
      client.POST('/concierge', {
        body,
      }),
    )
  },
  async subscribeToConcierge(physicianId: number) {
    return wrapEndpoint(() =>
      client.PATCH('/concierge/subscribe/physician/{id}', {
        params: {
          path: {
            id: physicianId,
          },
        },
      }),
    )
  },
  async unsubscribeToConcierge(physicianId: number) {
    return wrapEndpoint(() =>
      client.PATCH('/concierge/unsubscribe/physician/{id}', {
        params: {
          path: {
            id: physicianId,
          },
        },
      }),
    )
  },
}
